import { render, staticRenderFns } from "./AggiornaQuestionario.vue?vue&type=template&id=8f03e456&"
import script from "./AggiornaQuestionario.vue?vue&type=script&lang=js&"
export * from "./AggiornaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports